
import React from "react";
import { useSet, useDetail } from "seed/gql";
import { FLOW_NOTE, SET_FLOW_NOTE } from "seed/gql/queries";
import { Loading } from "seed/helpers";
import View from "components/presentation/history/notes/NoteFormView.view"

const FlowNoteForm = ({ noteId, closeModal, refreshNotes }) => {

  const reqFlowNote = useDetail(`{
    flowNote {
      title
      description
      message {
        action
        content
      }
    }  
  }`, noteId);

  const [callSetNote] = useSet(SET_FLOW_NOTE, {
    onCompleted: (data) => {
      refreshNotes();
      closeModal();
    }
  });

  const onClickSet = (values) => {
    callSetNote({
      ...values,
    });
  }

  const flowNote = reqFlowNote.data?.flowNote || {};
  if (reqFlowNote.loading) return <Loading />;

  const message = flowNote.message || {};

  return <View
    isEditing={true}
    message={message}
    flowNote={flowNote}
    onClickSubmit={onClickSet}
  />;

}

export default FlowNoteForm;